<template>
  <div :class="['acc_item', { product_height: btnImage, no_height: isContentVisible }, btnImageFormat]" v-on:click="switchContent">
     <div v-if="btnImage" class="img">
       <img v-if="btnImageFormat == 'portrait'" v-bind:src="getPolopolyImgUrl( btnImage, 'format_top1_portrait-hq' )" class="acc_btn_img"/>
       <img v-else v-bind:src="getPolopolyImgUrl( btnImage )" class="acc_btn_img"/>
       </div>
    <div class="acc_btn_upline" v-bind:class="{ acc_btn_centered:btnImage }" v-if="btnUpline">{{ btnUpline }}</div>
    
    <div v-if="btnImage && btnUpline" class="acc_btn_headline_img">{{ btnHeadline }} 
      <svg class="acc_arrow" v-bind:class="{ acc_arrow_down:isContentVisible }" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.9961 11.0002L11.9961 14.0002L8.99609 11.0002M20.9961 12.0002C20.9961 16.9707 16.9667 21.0002 11.9961 21.0002C7.02553 21.0002 2.99609 16.9707 2.99609 12.0002C2.99609 7.02959 7.02553 3.00015 11.9961 3.00015C16.9667 3.00015 20.9961 7.02959 20.9961 12.0002Z" stroke="#212529" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg> 
        </div>
    <div v-else-if="btnImage" class="acc_btn_headline_img_solo">{{ btnHeadline }} 
      <svg class="acc_arrow" v-bind:class="{ acc_arrow_down:isContentVisible }" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.9961 11.0002L11.9961 14.0002L8.99609 11.0002M20.9961 12.0002C20.9961 16.9707 16.9667 21.0002 11.9961 21.0002C7.02553 21.0002 2.99609 16.9707 2.99609 12.0002C2.99609 7.02959 7.02553 3.00015 11.9961 3.00015C16.9667 3.00015 20.9961 7.02959 20.9961 12.0002Z" stroke="#212529" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg> 
        </div>
    <div v-else class="acc_btn_headline">{{ btnHeadline }}
      <svg class="acc_arrow" v-bind:class="{ acc_arrow_down:isContentVisible }" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M14.9961 11.0002L11.9961 14.0002L8.99609 11.0002M20.9961 12.0002C20.9961 16.9707 16.9667 21.0002 11.9961 21.0002C7.02553 21.0002 2.99609 16.9707 2.99609 12.0002C2.99609 7.02959 7.02553 3.00015 11.9961 3.00015C16.9667 3.00015 20.9961 7.02959 20.9961 12.0002Z" stroke="#212529" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg> 
        </div>

    
    <div class="acc_image" v-if="isContentVisible">
    <img v-if="accImgID" v-bind:src="getPolopolyImgUrl( accImgID, contentImgDerivate)">
     <div class="acc_img_subline" v-if=accImgSubline>{{ accImgSubline }} <br></div>
     <div class="acc_img_credit" v-if=accImgCredit>Foto: {{ accImgCredit }}</div>
    </div>
    <div v-if="isContentVisible" class="acc_content" v-html="accMainText"> {{ accMainText }} </div>
    <div v-if="isContentVisible" class="acc_plus">
    <div v-if="accContextual" class="acc_contextual" v-html="accContextual"> {{ accContextual }}</div> 
    <div v-if="accGrade"  class="acc_grade">{{ accGrade }}</div> 
</div>
  </div>

</template>

<script>

export default {
  name: 'AccItem',
  props: {
    btnHeadline: String,
    btnImage: String,
    btnImageFormat: String,
    btnUpline: String,
    accMainText: String,
    accGrade: String,
    accContextual: String,
    accImgID: String,
    accFormat: String,
    accImgCredit: String,
    accImgSubline: String
  },
  data() {
        return {
            isContentVisible: false
        }
    },
    computed: {
       contentImgDerivate: function () {
        if (this.accFormat == '1-1')
        return 'format_top1_portrait-hq'
        if (this.accFormat == '16-9')
        return 'media_in_article_large'
        if (this.accFormat == '8-3')
        return 'format8_3-retina'
        else  
        return 'media_in_article_large_original'
    }
    
  },
    
    methods: { 
    getPolopolyImgUrl: function (id, derivate) {

      if (!derivate){
        return 'https://www.faz.net/ppmedia/' + id + '/media_in_article_large_original'
      } else {
        return 'https://www.faz.net/ppmedia/' + id + '/'+derivate
      }
      
    },
      switchContent: function () {
        this.isContentVisible = !this.isContentVisible
      }}

  }
  

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../assets/styles.css';
</style>